module.exports = __webpack_public_path__ + "img/qx_icon1.0c643d33.png";